import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRightIcon, TrophyIcon } from 'lucide-react';
export function ActionSection() {
  return <Section id="action" background="white" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-warm-white p-8 rounded-2xl border-2 border-teal/10 mb-16 text-center" data-id="element-27">
          <div className="inline-flex items-center justify-center p-3 bg-teal/10 rounded-full text-teal mb-6" data-id="element-28">
            <TrophyIcon className="h-8 w-8" data-id="element-29" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-navy mb-4" data-id="element-30">
            Tu primera victoria (hoy)
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-31">
            No te voy a pedir que cambies tu vida. Solo que hagas esto hoy:
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-32">
            {['6 exhalaciones largas', '60s de piernas', 'Mano en pecho 60s', 'Guion de 20s'].map((item, i) => <div key={i} className="bg-white p-4 rounded-lg shadow-sm font-medium text-navy text-sm md:text-base flex items-center justify-center text-center h-full" data-id="element-33">
                {item}
              </div>)}
          </div>

          <p className="text-xl font-medium text-teal italic" data-id="element-34">
            Si bajas 2 puntos, ya ganaste. Porque mañana no empiezas desde el
            mismo lugar.
          </p>
        </motion.div>

        <div className="text-center space-y-8" id="precio" data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-bold text-navy" data-id="element-36">
            Empieza hoy mismo
          </h2>
          <p className="text-xl text-gray-600" data-id="element-37">
            Sin apps. Sin equipo. Sin procesos eternos.
            <br data-id="element-38" />
            Solo un protocolo corto que tu cuerpo entiende.
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex justify-center" data-id="element-39">
            <img src="https://cdn.magicpatterns.com/uploads/pnmLnCBDvUJF6XXtrV8i5k/heylloyd-image-RESET_10_MIN.png" alt="El Reset de 10 Minutos para tu Sistema Nervioso" className="w-full max-w-sm rounded-xl shadow-lg" data-id="element-40" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex flex-col items-center bg-warm-white border-2 border-teal/20 rounded-2xl px-8 py-6 mx-auto" data-id="element-41">
            <p className="text-sm font-medium text-gray-400 uppercase tracking-wide mb-1" data-id="element-42">
              Precio especial de lanzamiento
            </p>
            <div className="flex items-baseline gap-3 mb-1" data-id="element-43">
              <span className="text-lg text-gray-400 line-through" data-id="element-44">$14.99</span>
              <span className="text-5xl md:text-6xl font-bold text-navy" data-id="element-45">
                $6
              </span>
              <span className="text-3xl md:text-4xl font-bold text-navy" data-id="element-46">
                .39
              </span>
              <span className="text-lg text-gray-500 font-medium" data-id="element-47">USD</span>
            </div>
            <p className="text-teal font-semibold text-sm" data-id="element-48">
              Ahorras más del 57%
            </p>
          </motion.div>

          <div className="flex flex-col items-center gap-4" data-id="element-49">
            <Button className="w-full md:w-auto text-lg px-12 py-6 h-auto" href="https://resetlab.it.com/cart/47657422684398:1" data-id="element-50">
              Quiero mi Reset de 10 Minutos{' '}
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-51" />
            </Button>
            <p className="text-sm text-gray-500" data-id="element-52">
              Descarga digital inmediata • Acceso de por vida
            </p>
          </div>
        </div>
      </div>
    </Section>;
}